module.exports = __webpack_public_path__ + "static/amber_golem-3e4cc5d4b8fd3b7130cdf98133347df5.png";